import { atom } from "jotai";
import { DEFAULT_SIMILARITY_THRESHOLD } from "./ComparativeAnalysisPage.constants";

export const metricGroupsScoresAtom = atom({});

export const similarityThresholdAtom = atom(DEFAULT_SIMILARITY_THRESHOLD);
